<template>
    <validation-observer v-slot="{ invalid }" ref="form" class="form mx-auto">
        <slot name="header">
            <h4 class="mb-4">Report Access</h4>
        </slot>

        <b-form-group class="mb-0">
            <b-input-group class="input-group-alternative input-group-merge">
                <div class="input-group-prepend">
                    <span class="input-group-text"><i class="fas fa-search"></i></span>
                </div>
                <b-form-input
                    @input="onSearch"
                    placeholder="Search"
                    type="text"
                ></b-form-input>
            </b-input-group>
        </b-form-group>

        <b-form @submit.prevent="submitForm">
            <b-overlay :show="fetchingItems" variant="white" opacity="1" no-fade>
                <template #overlay>
                    <b-icon
                        icon="three-dots"
                        animation="cylon"
                        variant="primary"
                        scale="2"
                        shift-v="8"
                        shift-h="8"
                        class="position-absolute"
                    ></b-icon>
                </template>

				<MembersCheckboxList 
					v-if="'member' == listType"
					v-model="picked" 
					:company-id="companyId" 
					:search-keyword="searchQuery" 
					:include-reports="1 < selected.length" />
				<template v-else>
					<div v-if="0 < listOptions.length" class="mt-4 overflow-auto reports">
						<b-form-checkbox
							@change="selectAll"
							:checked="isAllSelected"
							:disabled="
								'company' === assignTo && 'Company' === currentUser.role
							"
							class="text-capitalize"
							>All {{ listTypeName }}</b-form-checkbox
						>

						<b-form-group>
							<b-form-checkbox-group
								v-if="'company' == listType"
								v-model="picked"
								stacked
							>
								<b-form-checkbox
									v-for="listOption in listOptions"
									:value="listOption.value"
									:key="`option-${listOption.value}`"
								>
									<span class="d-flex justify-content-between">
										{{ listOption.text }}
										<a
											v-if="
												isUserRole('Superuser') &&
												inArray(listOption.value, picked)
											"
											@click.prevent="
												pushOrSplice(
													listOption.value,
													assignAllMembers
												)
											"
											:class="{
												'font-weight-bold': inArray(
													listOption.value,
													assignAllMembers
												),
											}"
											class="text-info ml-auto mr-2 small"
											href
											>Assign To All Users</a
										>
									</span>

									<template v-if="'report' == assignFrom">
										<ul
											v-if="1 < selected.length"
											class="my-2 pl-3 small"
										>
											<li
												v-for="report in reportSvc.reports.results"
												:key="`report-${
													report.report_id || report.id
												}`"
												:class="{
													'text-gray':
														0 <=
														checkReportIndex(
															listOption.reports,
															report
														),
												}"
												class="text-info"
											>
												<s
													v-if="
														0 <=
														checkReportIndex(
															listOption.reports,
															report
														)
													"
												>
													{{ reportNameByRole(report) }}
												</s>
												<template v-else>
													{{ reportNameByRole(report) }}
												</template>
											</li>
										</ul>
									</template>
								</b-form-checkbox>
							</b-form-checkbox-group>
							<b-form-checkbox-group v-else v-model="picked" stacked>
								<b-form-checkbox
									v-for="listOption in listOptions"
									:value="listOption.value"
									:key="`option-${listOption.value}`"
									:disabled="
										('company' === assignTo &&
											'Company' === currentUser.role) ||
										(newResource && listOption.value == defaultReport)
									"
								>
									<span class="d-flex align-items-center">
										{{ listOption.text }}

										<template v-if="isUserRole('Superuser')">
											<a
												v-if="inArray(listOption.value, picked)"
												@click.stop.prevent="
													selectDefaultReport(listOption.value)
												"
												:class="{
													'text-primary font-weight-bold':
														defaultReport === listOption.value,
													'text-muted':
														defaultReport !== listOption.value,
													'd-none':
														newResource &&
														listOption.value != defaultReport,
												}"
												class="small ml-auto"
												href
												>Set Default</a
											>
										</template>
									</span>
								</b-form-checkbox>
							</b-form-checkbox-group>
						</b-form-group>
					</div>
					<p v-else class="reports mt-4 small">No {{ listTypeName }} available.</p>
				</template>
			</b-overlay>

            <div class="mt-4 d-flex justify-content-between">
                <slot name="return"></slot>
                <slot name="submit">
                    <base-button
                        :disabled="invalid"
                        :loading="formProcessing"
                        type="primary"
                        native-type="submit"
                        size="md"
                        class="form-btn font-weight-normal"
                    >
                        <slot name="submit-text">Save</slot>
                    </base-button>
                </slot>
            </div>
        </b-form>
    </validation-observer>
</template>

<script>
import Fuse from "fuse.js";
import { debounce, compact, orderBy, uniq } from "lodash-es";

import { arrayMixin, userMixin, reportMixin } from "@mixins";
import MembersCheckboxList from "@components/MembersCheckboxList.vue";

export default {
    name: "form-report-access",
    components: {
        MembersCheckboxList,
    },
    props: {
        listType: {
            type: String,
            default: "report",
        },
        assignFrom: {
            type: String,
            default: "report",
        },
        assignTo: {
            type: String,
            default: "member",
        },
        companyId: [Number, String, Boolean],
        params: {
            type: Object,
            default: () => ({
                page_size: 500,
            }),
        },
        selected: {
            type: Array,
            default: () => [],
        },
        excludes: {
            type: Array,
            default: () => [],
        },
        instance: {
            type: Object,
            default: () => ({
                type: "Employee",
            }),
        },
        newUser: [Object, Boolean],
        newResource: {
            type: Boolean,
            description: "Whether the resource is new.",
        },
        commitSubmit: {
            type: Boolean,
            default: true,
        },
    },
    inject: ["companySvc", "ErrorService", "memberSvc", "reportSvc", "profileSvc"],
    mixins: [arrayMixin, userMixin, reportMixin],
    data() {
        return {
            formProcessing: false,
            fetchingItems: true,
            searchQuery: "",
            listItems: [],
            assignedReports: [],
            assignAllMembers: [],
            picked: [],
            defaultReport: null,
            newUserCreated: null,
        };
    },
    computed: {
        user() {
            return this.newUserCreated || this.instance;
        },
        model() {
            let model = [];

            if ("report" === this.listType) {
                if (0 < this.selected.length) {
                    this.selected
                        .filter((sitem) => {
                            return 0 < sitem.items.length;
                        })
                        .forEach((sitem) => {
                            sitem.items.forEach((siitem) => {
                                let key = this.newUser
                                    ? this.newUser.id
                                    : this.instance.id;

                                if ("company" === this.assignTo)
                                    key =
                                        this.companyId ||
                                        (this.instance ? this.instance.company.id : null);

                                let mindex = model.findIndex(
                                    (mitem) => mitem.key === siitem || key
                                );

                                if (0 <= mindex) model[mindex].reports = this.picked;
                                else
                                    model.push({
                                        key: siitem || key,
                                        reports: this.picked,
                                    });
                            });
                        });
                } else {
                    model = this.picked.map((pitem) => {
                        let key = this.newUser ? this.newUser.id : this.instance.id;

                        if ("company" === this.assignTo)
                            key =
                                this.companyId ||
                                (this.instance ? this.instance.company.id : null);

                        return {
                            key: key,
                            reports: [pitem],
                        };
                    });
                }

                if ("member" === this.assignTo && this.newUserCreated) {
                    model.push({
                        key: this.newUserCreated.id,
                        reports: this.picked,
                    });
                }
            } else {
                model = this.picked.map((pitem) => {
                    return {
                        key: pitem,
                        reports:
                            1 === this.selected.length
                                ? [this.selected[0].id]
                                : this.selected.map((sitem) => sitem.id),
                    };
                });
            }

            return model;
        },
        listTypeName() {
            switch (this.listType) {
                case "report":
                    return "Reports";
                case "company":
                    return "Companies";
                case "member":
                    return "Members";
                default:
                    return "";
            }
        },
        listOptions() {
            let items = this.listItems,
                fuse = new Fuse(items, {
                    keys: ["text"],
                    includeScore: true,
                    useExtendedSearch: true,
                    threshold: 0.3,
                });

            if ("" !== this.searchQuery)
                items = fuse.search(this.searchQuery).map((item) => item.item);

            const nameSort = (item) => item.text.toLowerCase();

            return orderBy(items, [nameSort], ["asc"]);
        },
        isAllSelected() {
            if (this.fetchingItems) return false;

            return this.picked.length >= this.listOptions.length;
        },
    },
    watch: {
        formProcessing: function (val) {
            this.$bus.$emit("report-access-form-processing", val);
        },
        listOptions: function (val) {
            if (val && 0 < val.length) this.checkSelected();
        },
        selected: {
            deep: true,
            immediate: true,
            handler: function (val) {
                this.assignedReports = val;
            },
        },
        picked: {
            immediate: true,
            handler: function (val) {
                if ("report" !== this.listType) return false;

                if (0 < val.length) {
                    const idx = val.indexOf(this.defaultReport);

                    this.defaultReport = 0 > idx ? val[0] : this.defaultReport;
                } else {
                    this.defaultReport = null;
                }
            },
        },
    },
    methods: {
        onSearch: debounce(function (keyword) {
            this.searchQuery = keyword;
        }, 500),
        async fetchItems() {
            var response;

            if ("report" == this.listType) {
                response = await this.reportSvc.list(this.params, false);

                this.listItems = response.data.data.data
                    .filter((item) => {
                        return 0 > this.excludes.indexOf(item.report_id || item.id);
                    })
                    .map((item) => {
                        return {
                            value: item.report_id || item.id,
                            text: this.currentUser.is_superuser
                                ? item.name
                                : item.display_name || item.name,
                        };
                    });
            } else if ("company" == this.listType) {
                response = await this.companySvc.list(this.params, false);

                this.listItems = response.data.data.results.map((item) => {
                    return {
                        value: item.id,
                        text: item.name,
                        reports: item.reports,
                    };
                });
            } else if ("member" == this.listType) {
                response = await this.memberSvc.list(this.params, false);

                this.listItems = response.data.data.data.members.results.map((item) => {
                    return {
                        value: item.id,
                        text: item.user.first_name,
                        reports: item.reports,
                    };
                });
            }

            this.fetchingItems = false;
        },
        async getCompanyDefaultReport() {
            if (!this.companyId) return false;

            const rs = await this.companySvc.read(
                {
                    id: this.companyId,
                },
                false
            );

            this.defaultReport = rs.data.data.data.default_report_id;
            this.picked.push(this.defaultReport);
        },
        selectAll(checked) {
            this.picked = checked
                ? this.listOptions.map((iitem) => iitem.value)
                : this.companyId && this.defaultReport
                ? [this.defaultReport]
                : [];
        },
        selectDefaultReport(reportId) {
            if (this.newResource && this.defaultReport === reportId) return false;

            this.defaultReport =
                this.defaultReport && this.defaultReport === reportId ? null : reportId;
        },
        checkReportIndex(reports, report) {
            return reports.findIndex(
                (ritem) => ritem.report_id === (report.report_id || report.id)
            );
        },
        checkSelected() {
            if (!this.selected.length) return false;

            if ("report" === this.listType) {
                this.picked = this.listOptions
                    .filter((iitem) => {
                        const sindex = this.selected.findIndex(
                            (sitem) => sitem.id === iitem.value
                        );

                        return 0 <= sindex;
                    })
                    .map((iitem) => iitem.value);
            } else {
                this.selected
                    .filter((sitem) => {
                        return 1 < this.selected.length ? true : 0 < sitem.items.length;
                    })
                    .forEach((sitem) => {
                        this.picked = uniq(this.picked.concat(sitem.items));
                    });
            }
        },
        async createUser() {
            if (this.newUser) {
                const response = await this.memberSvc.create(this.newUser);

                this.newUserCreated = response.data.data.data;

                this.$bus.$emit("report-access-user-created", this.newUserCreated);
            }
        },
        async unassignReports() {
            if (0 < this.selected.length) {
                const unassignList = this.selected.filter((sitem) => {
                    if ("report" === this.listType)
                        return 0 > this.picked.indexOf(sitem.id);
                    else return true;
                });

                for (const unassignItem of unassignList) {
                    if (0 < unassignItem.assigned_items.length) {
                        const assignedList = unassignItem.assigned_items.filter(
                            (aitem, aitem_i) => {
                                return "report" === this.listType
                                    ? true
                                    : 0 >
                                          this.picked.indexOf(
                                              unassignItem.items[aitem_i]
                                          );
                            }
                        );

                        for (const assignedItem of assignedList) {
                            const arindex = this.assignedReports.findIndex(
                                (aritem) => aritem.id === unassignItem.id
                            );

                            if (0 <= arindex) this.assignedReports.splice(arindex, 1);

                            await this.reportSvc.unassignAccess(
                                { id: assignedItem },
                                "member" === this.assignTo ? true : false
                            );

                            this.$bus.$emit("report-access-unassigned", {
                                id: assignedItem,
                                report_id: unassignItem.id,
                                [`${this.assignTo}_id`]: unassignItem.items[0],
                            });
                        }
                    }
                }
            }
        },
        async assignReports() {
            const assignList = this.model.filter((mitem) => {
                const filteredRps = mitem.reports.filter((ritem) =>
                    0 <= this.excludes.indexOf(ritem) ? false : true
                );

                return mitem.key && compact(filteredRps).length;
            });

            for (const assignItem of assignList) {
                const reportList = assignItem.reports.filter((ritem) => {
                    if ("report" === this.listType)
                        return 0 > this.selected.findIndex((sitem) => sitem.id === ritem);
                    else return true;
                });

                if (0 < reportList.length) {
                    await this.reportSvc
                        .assignAccess(
                            {
                                report_list: reportList.filter((item) => item),
                                [`${this.assignTo}_list`]: [assignItem.key],
                                company_id: this.companyId,
                            },
                            "member" === this.assignTo ? true : false,
                            this.commitSubmit
                        )
                        .then(async (response) => {
                            const data = response.data.data.data;

                            this.assignedReports = this.assignedReports.concat(
                                data.map((ditem) => {
                                    return {
                                        id: ditem.report.id,
                                        items: [
                                            "company" === this.assignTo
                                                ? ditem.company.id
                                                : ditem.member.id,
                                        ],
                                        assigned_items: [ditem.id],
                                    };
                                })
                            );

                            if (this.assignAllMembers.length)
                                for await (const item of data) {
                                    if (
                                        !this.inArray(
                                            item.company.id,
                                            this.assignAllMembers
                                        )
                                    )
                                        continue;

                                    await this.assignToAllMembers(
                                        [item.report.id],
                                        item.company.id
                                    );
                                }

                            this.$bus.$emit("report-access-assigned", data);
                        });
                }
            }
        },
        async assignDefaultReport() {
            if (this.defaultReport && 0 < this.assignedReports.length) {
                if (
                    (this.instance && "undefined" !== typeof this.instance.user) ||
                    (this.newUserCreated &&
                        "undefined" !== typeof this.newUserCreated.user)
                ) {
                    const arindex = this.assignedReports.findIndex(
                        (aritem) => aritem.id === this.defaultReport
                    );

                    if (0 <= arindex && (this.newUserCreated || this.instance.user)) {
                        await this.profileSvc.setDefaultReport(
                            {
                                user_id: this.newUserCreated
                                    ? this.newUserCreated.user.id
                                    : this.instance.user.id,
                                default_report: this.assignedReports[arindex]
                                    .assigned_items[0],
                            },
                            false
                        );
                    }
                }

                if (
                    this.defaultReport != this.companySvc.company.default_report_id &&
                    this.companySvc.company.id
                )
                    await this.companySvc.update(
                        {
                            ...this.companySvc.company,
                            default_report_id: this.defaultReport,
                        },
                        false
                    );

                this.$store.commit("UPDATE_COMPANY_DATA", {
                    key: "default_report_id",
                    value: this.defaultReport,
                });
            } else {
                if ("member" === this.assignTo && this.defaultReport) {
                    const rs = await this.reportSvc.assignAccess(
                        {
                            report_list: [this.defaultReport],
                            member_list: [this.user.id],
                            company_id: this.user.company,
                        },
                        true,
                        this.commitSubmit
                    );

                    this.$bus.$emit("report-access-assigned", rs.data.data.data);

                    await this.profileSvc.setDefaultReport(
                        {
                            user_id: this.user.user.id,
                            default_report: rs.data.data.data[0].id,
                        },
                        false
                    );
                }
            }
        },
        async submitForm() {
            this.formProcessing = true;

            await this.createUser();
            await this.assignReports();
            await this.unassignReports();
            await this.assignDefaultReport();

            if (this.picked.length) this.$toasted.show("Reports assigned successfully.");

            this.$bus.$emit("report-access-form-success", this.assignedReports);

            this.formProcessing = false;
        },
        reset() {
            this.reportSvc.set("report", null);
            this.memberSvc.set("member", null);

            Object.assign(this.$data, this.$options.data.apply(this));
        },
    },
    async created() {
        if (this.instance.user) {
            const response = await this.profileSvc.getDefaultReport({
                user_id: this.instance.user.id,
            });

            this.defaultReport = response.data.data.data.report_id;
        }
    },
    mounted() {
        this.ErrorService.stopProcessingOnFail(this);

        this.fetchItems();

        if ("report" === this.listType && "company" === this.assignTo)
            this.getCompanyDefaultReport();
    },
    beforeDestroy() {
        this.reset();
    },
};
</script>

<style lang="scss">
.reports {
    height: 190px;

    .custom-control {
        margin-bottom: 0.5rem;
    }
}
</style>
